import React from 'react'
import './index.css'

// Shimmer rows for a table that is still loading.
//
// `columns` takes the SAME width strings the real table uses, so the skeleton occupies the
// exact column layout the data will - no reflow when the rows arrive.
//
// Rendered with the table's own ._tr/._td classes so it inherits row height, borders and
// padding from whichever table stylesheet is in play (there are 21 near-identical copies of
// those rules; this deliberately reuses them rather than adding a 22nd).
const Index = ({columns = ['25%','25%','25%','25%'], rows = 5}) => {
  return (
    <>
      {Array.from({length: rows}).map((_,rowIndex)=>(
        <div className='_tr' key={rowIndex}>
          {columns.map((width,colIndex)=>(
            <div className='_td' style={{width: width}} key={colIndex}>
              {/* Width varies per cell so the block reads as text, not as a progress bar.
                  Deterministic from the indices - Math.random() would reshuffle on every
                  re-render and make the skeleton twitch. */}
              <span
                className='nv-skeleton__bar'
                style={{width: (55 + ((rowIndex * 7 + colIndex * 13) % 35)) + '%'}}
              />
            </div>
          ))}
        </div>
      ))}
    </>
  )
}

export default Index
